export default __webpack_public_path__ + "static/media/Bracers of the Membranous.2e089ae3.jpg";